/**
 * ChartMeta — the one line over the chart's tabs (the prototype's "5 documents from 1 provider"): true facts only, read from
 * the first page of the patient's documents (`usePatientDocuments`, the same query the Documents tab and the Overview read).
 * Nothing while it loads, on an error, or with no documents: no line is better than a wrong one.
 */
import { usePatientDocuments } from '@/patients/services/use-patient-documents';
import { documentsSummary } from '@/patients/lib/chart-overview';
import { liveRows } from '@/patients/lib/overview-headlines';

export const CHART_META_PAGE_SIZE = 20;

export function ChartMeta({ patientId }: { patientId: string }) {
  const q = usePatientDocuments({ patientId, pageSize: CHART_META_PAGE_SIZE });
  if (q.isLoading || q.isError) return null;
  const line = documentsSummary(liveRows(q.data), CHART_META_PAGE_SIZE);
  return line ? <p data-slot="patient-chart-meta">{line}</p> : null;
}
